import QuestionMessageBlock from './QuestionMessageBlock.jsx';
import LinkedEventPreview from './LinkedEventPreview.jsx';
import { DetailSections } from '../shared/index.js';

/**
 * Question event detail body — prototype card + optional linked event.
 */
function QuestionBody({ event }) {
  const detail = event.detail ?? {};

  const sections = [
    <QuestionMessageBlock
      key="message"
      event={event}
      detail={detail}
      situation={event.situation ?? event.description}
      askedAt={detail.askedAt ?? null}
    />,
    detail.linkedEvent ? (
      <LinkedEventPreview key="linked-event" linkedEvent={detail.linkedEvent} />
    ) : null,
  ].filter(Boolean);

  return <DetailSections sections={sections} />;
}

export default QuestionBody;
